import React from "react";
import { useNavigate } from "react-router-dom";
import { ActionRequiredQueryCard } from "./ActionRequiredQueryCard";
import type { ActionRequiredItemEntity } from "../../../domain/entities/BooksHealthEntity";

export interface YourActionsRequiredSectionProps {
  items?: ActionRequiredItemEntity[];
  loading?: boolean;
}

export function YourActionsRequiredSection({
  items = [],
  loading = false,
}: YourActionsRequiredSectionProps) {
  const navigate = useNavigate();
  const count = items.length;

  const handleAction = (item: ActionRequiredItemEntity) => {
    if (item.type === "query") {
      navigate("/client/queries");
    }
  };

  if (loading) {
    return (
      <div className="flex w-full flex-col items-start gap-4">
        <div className="flex items-center gap-2">
          <span className="text-caption-bold font-caption-bold text-neutral-500 uppercase tracking-wider">
            YOUR ACTION REQUIRED
          </span>
          <div className="h-5 w-16 animate-pulse rounded-full bg-neutral-200" />
        </div>
        <div className="h-24 w-full animate-pulse rounded-lg bg-neutral-100" />
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col items-start gap-4">
      <div className="flex items-center gap-2">
        <span className="text-caption-bold font-caption-bold text-neutral-500 uppercase tracking-wider">
          YOUR ACTION REQUIRED
        </span>
        {count > 0 && (
          <div className="flex items-center gap-1 rounded-full bg-error-50 px-2 py-0.5">
            <div className="flex h-2 w-2 flex-none flex-col items-start rounded-full bg-error-600" />
            <span className="text-caption-bold font-caption-bold text-error-700">
              {count} {count === 1 ? "item" : "items"}
            </span>
          </div>
        )}
      </div>
      {items.length === 0 ? (
        <div className="flex w-full items-center justify-between rounded-lg border border-solid border-neutral-200 bg-white px-6 py-5">
          <span className="text-body font-body text-neutral-500">
            No actions required right now.
          </span>
        </div>
      ) : (
        items.map((item) => (
          <ActionRequiredQueryCard
            key={item.id}
            {...item}
            onAction={() => handleAction(item)}
          />
        ))
      )}
    </div>
  );
}
